export default __webpack_public_path__ + "static/media/BanersW_PROMO_COCHE_500_330X330.e38bf1fe.png";